/** Fighter images + prop option labels (match original shell). */

export const METHOD_OPTIONS = ['KO/TKO', 'Submission', 'Decision'] as const
export const ROUND_OPTIONS = ['Round 1', 'Round 2', 'Round 3', 'Round 4', 'Round 5', 'Decision'] as const

export function avatarFor(id: string | undefined | null, image?: string | null): string {
  if (image) return image
  if (id) return `/assets/fighters/${id}.png`
  return '/assets/avatars/fighter-red.png'
}

export type Fixture = {
  fixtureId: string
  title?: string
  section?: string
  billing?: string | null
  weightClass?: string | null
  rounds?: number
  entrantIds?: string[]
  homeEntrantId?: string
  awayEntrantId?: string
  red?: {
    id: string
    name: string
    nickname?: string
    record?: string
    country?: string
    image?: string
  }
  blue?: {
    id: string
    name: string
    nickname?: string
    record?: string
    country?: string
    image?: string
  }
}

export function redOf(f: Fixture) {
  return (
    f.red || {
      id: f.homeEntrantId || f.entrantIds?.[0] || 'red',
      name: f.homeEntrantId || f.entrantIds?.[0] || 'Red',
    }
  )
}

export function blueOf(f: Fixture) {
  return (
    f.blue || {
      id: f.awayEntrantId || f.entrantIds?.[1] || 'blue',
      name: f.awayEntrantId || f.entrantIds?.[1] || 'Blue',
    }
  )
}

export const SECTION_LABELS: Record<string, string> = {
  main: 'Main card',
  prelim: 'Prelims',
  early: 'Early prelims',
}

/** Round choices limited to bout length (+ Decision for going the distance). */
export function roundsForBout(rounds?: number): string[] {
  const n = Math.min(Math.max(Number(rounds) || 3, 1), 5)
  const opts = Array.from({ length: n }, (_, i) => `Round ${i + 1}`)
  opts.push('Decision')
  return opts
}
